import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import AppointmentManager from './appointment_manager_listing/AppointmentManager'
import PropertyApproval from './property_approval/PropertyApproval'
import CompanyApproval from './company_approval/CompanyApproval'
import FreelancerApproval from './admin_agents_and_freelancer_approval/FreelancerApproval'
import AuthContext from 'context/AuthContext'

const tabBtnClass =
  'ml-3 inline-block py-3 px-2 text-md xl:text-sm font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_APPOINTMENT_MANAGER = 'appointment_manager'
const TAB_PROPERTY_APPROVAL = 'property_approval'
const TAB_COMPANY_APPROVAL = 'company_approval'
const TAB_ADMIN_AGENT_OR_FREELANCER_APPROVAL =
  'admin_agent_or_freelancer_approval'
const Approval = () => {
  const { t } = useTranslation()
  const { user, tab, setTab } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'approval_manager') ?? {}
  const [defaultTab, setDefaultTab] = useState(
    tab !== '' ? tab : 'appointment_manager'
  )
  const handleTabClick = (action, e) => {
    setDefaultTab(action)
    setTab(action)
  }
  return (
    <>
      <div className='pb-3'>
        <ul className='border-b flex'>
          <li className='mr-0'>
            <button
              onClick={handleTabClick.bind(this, TAB_APPOINTMENT_MANAGER)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_APPOINTMENT_MANAGER,
                [tabBorderNoneClass]: defaultTab !== TAB_APPOINTMENT_MANAGER
              })}
            >
              {t('O_APPOINTMENT_MANAGER')}
            </button>
          </li>
          <li className='mx-0'>
            <button
              onClick={handleTabClick.bind(this, TAB_PROPERTY_APPROVAL)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_PROPERTY_APPROVAL,
                [tabBorderNoneClass]: defaultTab !== TAB_PROPERTY_APPROVAL
              })}
            >
              {t('O_PROPERTY_APPROVAL')}
            </button>
          </li>
          <li className='mx-0'>
            <button
              onClick={handleTabClick.bind(this, TAB_COMPANY_APPROVAL)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_COMPANY_APPROVAL,
                [tabBorderNoneClass]: defaultTab !== TAB_COMPANY_APPROVAL
              })}
            >
              {t('O_COMPANY_APPROVAL')}
            </button>
          </li>
          <li className='mx-0'>
            <button
              onClick={handleTabClick.bind(
                this,
                TAB_ADMIN_AGENT_OR_FREELANCER_APPROVAL
              )}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]:
                  defaultTab === TAB_ADMIN_AGENT_OR_FREELANCER_APPROVAL,
                [tabBorderNoneClass]:
                  defaultTab !== TAB_ADMIN_AGENT_OR_FREELANCER_APPROVAL
              })}
            >
              {t('O_ADMIN_AGENT_AND_FREELANCER_APPROVAL')}
            </button>
          </li>
        </ul>
      </div>

      {defaultTab === TAB_APPOINTMENT_MANAGER && (
        <AppointmentManager manager={manager} />
      )}
      {defaultTab === TAB_PROPERTY_APPROVAL && (
        <PropertyApproval manager={manager} />
      )}
      {defaultTab === TAB_COMPANY_APPROVAL && (
        <CompanyApproval manager={manager} />
      )}
      {defaultTab === TAB_ADMIN_AGENT_OR_FREELANCER_APPROVAL && (
        <FreelancerApproval manager={manager} />
      )}
    </>
  )
}

export default Approval
